export const PROPERTIES_TO_INCLUDE = [
  'id',
  'name',
  'description',
  'src',
  'sizeOnCanvas',
  'boundingBox',
  'center',
  'transformation',
  'textProperties',
  'effects',
  'version',
  'blending',
  'absolutePositioned',
  'top',
  'left',
  'useBzrtBgMask',
  'fill',
  'layerAssetStateId',
  'bazaartGuid',
  'isLatest',
  'backgroundIdentifier',
  'filter',
  'filters',
  'filterIntensity',
  '_originalScaleX',
  '_originalScaleY',
  'sizeId',
  'scaleX',
  'scaleY',
  '_filterScalingX',
  '_filterScalingY',
  'evented',
  'cacheKey',
  'cacheCounter',
  'isTemplateLayer',
  'effects_from_template',
  'hasReplaceableLayer',
  'isStockImage',
  'centerPoint',
  'unit',
  'icon',
  'hasTransparency',
  'isMagicBackgroundLayer',
  'isInitializedNormalizeMask',
  'isInitializedNormalizedImage',
  'adjustments',
  'isResized',
  '_originalHeight',
  '_originalWidth',
  'hoverCursor',
  'source_platform',
  'keyFrames',
  'textMetadata',
  'originalFontSize',
  'convertedFromImage',
  'lockScalingFlip',
  'isTransparentBg'
]

export const PROPERTIES_TO_EXPORT = [
  'absoluteRotation',
  'adjustments',
  'audioVolume',
  'bazaartGuid',
  'boundingBox',
  // 'center', - we adding it manualy by copy from centerPoint
  'currentPrice',
  'effects',
  'filter',
  'filterIntensity',
  'hasFaceFeatures',
  'hasTransparency',
  'imageHeight',
  'imageWidth',
  'imagesFormat',
  'imagesLastUpdated',
  'imagesOrientation',
  'layerAssetStateId',
  'isDeleted',
  'isDirty',
  'isHidden',
  'isInitializing',
  'isLocked',
  'isPlaceholder',
  'isShopable',
  'isTemplateLayer',
  'itemType',
  'lastPrice',
  'opacity',
  'sizeOnCanvas',
  'state',
  'storeId',
  'thumbnailHeight',
  'thumbnailWidth',
  'transformation',
  'version',
  'zLayer',
  'backgroundIdentifier',
  'isAnimated',
  'isBackgroundImage',
  'startTime',
  '_endTime',
  'shouldUseMattedImage',
  'fullImgUrl',
  'hasPeople',
  'features',
  'textProperties',
  'sourceGraphicsItemName',
  'sourceGraphicsPackName',
  'sourceGraphicsType',
  'splitByGrapheme',
  'blending',
  'overlayType',
  'videoSpeed',
  'saliencyResults',
  'centerPoint',
  'videoMaskBoundingBox',
  'videoMaskType',
  'isLiftBackgroundLayer',
  'isMagicBackgroundLayer',
  'isLatest',
  'keyFrames',
  'isInitializedNormalizeMask',
  'isInitializedNormalizedImage',
  'textMetadata',
  'originalFontSize',
  'groupId',
  'convertedFromImage'
]

export const propertyMapping = {
  imageHeight: 'height',
  imageWidth: 'width',
  itemType: 'type',
}

export enum ObjectType {
  STATIC_VECTOR = 'StaticVector',
  GROUP = 'group',
  STATIC_PATH = 'StaticPath',
  DYNAMIC_PATH = 'DynamicPath',
  STATIC_IMAGE = 'StaticImage',
  BACKGROUND_IMAGE = 'BackgroundImage',
  STATIC_TEXT = 'StaticText',
  OPEN_TYPE_TEXT = 'OpenTypeText',
  FRAME = 'Frame',
  BAZAART_STICKER = 'bazaart.item.sticker',
  BAZAART_TEXT = 'bazaart.item.text',
  BAZAART_BREAKTEXT = 'BreakText',
  BAZAART_GROUP_BREAKTEXT = 'bazaart.item.groupBreakText',
  BAZAART_BG = 'bazaart.item.background',
  BAZAART_IMAGE = 'bazaart.item.image',
  BAZAART_SHAP = 'bazaart.item.shape',
  BAZAART_OVERLAY = 'bazaart.item.overlay',
  BAZAART_DRAWING = 'bazaart.item.drawing',
  ACTIVE_SELECTION = 'activeSelection',
  BAZAART_IMAGE_FROM_TEXT = 'bazaart.item.imageFromText',
  BAZAART_IMAGETEXT = 'bazaart.item.imageText',
}

export enum ObjectTypeFromAPI {
  BACKGROUND_LAYER = 'bazaart.CanvasBackgroundLayer',
  IMAGE_LAYER = 'bazaart.CanvasImageLayer',
  TEXT_LAYER = 'bazaart.CanvasTextLayer',
  STICKER_LAYER = 'bazaart.CanvasStickerLayer',
  OVERLAY_LAYER = 'bazaart.CanvasOverlayLayer',
  SHAPE_LAYER = 'bazaart.CanvasShapeLayer',
  VECTOR_LAYER = 'bazaart.CanvasVectorLayer',
  PATH_LAYER = 'bazaart.CanvasPathLayer',
  DRAWING_LAYER = 'bazaart.CanvasPathLayer',
}

// export enum ObjectTypeAlt {
//   STATIC_IMAGE = 'image:static',
//   DYNAMIC_IMAGE = 'image:dynamic',
//   TEXTAREA = 'Textarea'
// }

export type DRAGGABLE_TYPE = ObjectType.BAZAART_IMAGE | ObjectType.BAZAART_STICKER | 'Template' | ObjectType.BAZAART_TEXT
export type ToolType = '' | 'Remove' | 'Eraser' | 'Enhance' | 'MagicBg' | 'BoostDesign' | 'MagicTemplates'

export type ContextMenuAnchor = {
  rx: number // Capture click as ratio to layer width
  ry: number // Capture click as ratio to layer height
} | null
export type POSITION = 'top' | 'left' | 'right' | 'bottom'

export const BASE_FRAME_WIDTH = 2048
export const BASE_FRAME_HEIGHT = 2048

export enum ScaleType {
  FILL,
  FIT,
}

export enum CanvasCompositionMode {
  PAGES = "canvasComposition.pages",
  SCENES = "canvasComposition.scenes",
  PRESENTATION = "canvasComposition.presentation"
}

export enum ShowModalType {
  CUSTOM_SIZE,
  UNSUPPORTED_FILE_TYPE,
  DISCARD_PROJECT,
  DELETE_PROJECT,
  DOWNLOAD_PROJECT,
  DOWNLOAD_APP,
  QUICK_TUTORIAL,
  CANCEL_TUTORIAL,
  GOOD_WORK_MODAL,
  PROJECT_OPEN_FAILED,
  PROJECT_ALREADY_OPEN,
  ONBOARDING,
  CONFIRM_SIGN_OUT,
  NO_INTERNET,
  SIGN_IN,
  SIGN_IN_1ST,
  WHAT_NEW,
  ENHANCE_ERROR,
  MAGIC_DESIGN,
  CUSTOM_TEXT,
  FIRST_TIME_BOOST_DESIGN,
  LIMITED_TIME_OFFER,
  LIMITED_OFFER,
}

export const LIST_LANGUAGE = [
  // { id: 2, label: 'العربية', desc: 'Arabic', value: 'ar'},
  { id: 1, label: 'English', desc: 'English', value: 'en'},
  { id: 3, label: 'Français', desc: 'French', value: 'fr' },
  { id: 4, label: 'Deutsch', desc: 'German', value: 'de' },
  // { id: 5, label: 'עברית', desc: 'Hebrew', value: 'he' },
  { id: 6, label: 'Italiano', desc: 'Italian', value: 'it' },
  { id: 7, label: '日本語', desc: 'Japanese', value: 'ja' },
  { id: 8, label: '한국어', desc: 'Korean', value: 'ko' },
  { id: 9, label: 'Português', desc: 'Portuguese - brazil', value: 'pt' },
  { id: 10, label: 'Русский', desc: 'Russian', value: 'ru' },
  { id: 11, label: '简体中文', desc: 'Simplified Chinese', value: 'zh-Hans' },
  { id: 12, label: 'Español', desc: 'Spanish', value: 'es' },
  { id: 13, label: '繁體中文', desc: 'Traditional Chinese', value: 'zh-Hant' },
  { id: 14, label: 'Türkçe', desc: 'Turkish', value: 'tr' },
]

export const SHOW_DOWNLOAD_APP_TIME_DURATION = 3000

export enum SAVE_PROJECT_STATE {
  INIT,
  LOADING,
  SUCCESS,
  END
}

export const ONLINE_CHECK_INTERVAL = 3000
export const CLOSE_TOAST_COMPLETED = 5000
export const DEFAULT_FONT = 'Poppins-SemiBold'
export const DARK_OVERLAY_EXPOSURE_VALUE = -1.08
export const NON_SIGNUP_USER_MESSAGE = 30000

export const REMOVE_OBJECT_TRANSITION_VALUE = 700
export enum TEXT_ALIGN {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}

export enum AI_STYLE_RATIO  {
  SQUARE = '1024x1024',
  PORTRAIT = '1024x1536',
  LANDSCAPE = '1536x1024',
  AUTO = 'auto'
}

export enum AI_STYLE_QUALITY  {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
}

export enum ModelToRun {
  DEFAULT = 'qwen',
  OPENAI = 'openai',
  GEMINI = 'gemini',
  GEMINI_3_1 = 'gemini_3_1',
  FLUX = 'flux',
  QWEN = 'qwen'
}
